import React from 'react';
import IconBase from './IconBase';

const DictionaryEditIcon = props => {
    return (
        <IconBase viewBox={'0 0 40 40'} {...props}>
            <path d="M6.7,23.7h1.9l1-2.8h4.3l1,2.8h1.8l-4-10.8h-1.9L6.7,23.7z M10,19.4l1.6-4.5h0.1l1.6,4.5H10z M23.3,16.2v-2.3
	c0.9-0.4,1.9-0.7,2.8-0.9s2-0.3,3-0.3c0.7,0,1.4,0.1,2.1,0.2c0.7,0.1,1.4,0.2,2,0.4v2.1c-0.7-0.2-1.3-0.4-2-0.6
	c-0.7-0.1-1.4-0.2-2.1-0.2c-1.1,0-2.1,0.1-3,0.4S24.2,15.7,23.3,16.2z M23.3,25.4v-2.3c0.9-0.4,1.9-0.7,2.8-0.9c1-0.2,2-0.3,3-0.3
	c0.7,0,1.4,0.1,2.1,0.2c0.7,0.1,1.4,0.2,2,0.4v2.1c-0.7-0.2-1.3-0.4-2-0.6c-0.7-0.1-1.4-0.2-2.1-0.2c-1.1,0-2.1,0.1-3,0.4
	S24.2,24.9,23.3,25.4z M23.3,20.8v-2.3c0.9-0.4,1.9-0.7,2.8-0.9c1-0.2,2-0.3,3-0.3c0.7,0,1.4,0.1,2.1,0.2c0.7,0.1,1.4,0.2,2,0.4v2.1
	c-0.7-0.2-1.3-0.4-2-0.6c-0.7-0.1-1.4-0.2-2.1-0.2c-1.1,0-2.1,0.1-3,0.4S24.2,20.3,23.3,20.8z M21.4,29.2c1.3-0.7,2.7-1.2,4-1.5
	c1.3-0.3,2.7-0.5,4.1-0.5c1,0,2.1,0.1,3.2,0.2c1.1,0.2,2,0.4,2.9,0.7V10.7c-0.9-0.4-1.9-0.8-2.9-1c-1-0.2-2.1-0.3-3.1-0.3
	c-1.4,0-2.8,0.2-4.2,0.6c-1.4,0.4-2.6,1-3.9,1.8V29.2z M20.1,33.3c-1.4-1.1-2.9-1.9-4.5-2.4c-1.6-0.6-3.3-0.9-5-0.9
	c-1.1,0-2.1,0.1-3.1,0.4c-1,0.3-2,0.6-3,1c-0.6,0.3-1.2,0.3-1.8-0.1C2,31,1.7,30.5,1.7,29.8V10.2c0-0.4,0.1-0.7,0.3-1.1
	c0.2-0.3,0.5-0.6,0.8-0.8c1.2-0.6,2.5-1,3.8-1.3c1.3-0.3,2.6-0.4,4-0.4c1.7,0,3.4,0.2,5,0.7c1.6,0.5,3.1,1.1,4.6,2.1
	c1.4-0.9,2.9-1.6,4.5-2.1c1.6-0.5,3.2-0.7,4.9-0.7c1.3,0,2.7,0.1,4,0.4c1.3,0.3,2.5,0.7,3.8,1.3c0.4,0.2,0.6,0.4,0.8,0.8
	c0.2,0.3,0.3,0.7,0.3,1.1v19.6c0,0.7-0.3,1.3-0.9,1.7c-0.6,0.4-1.2,0.4-1.8,0c-1-0.4-2-0.8-3-1.1c-1-0.3-2.1-0.4-3.1-0.4
	c-1.7,0-3.4,0.3-5,0.9C22.9,31.5,21.4,32.3,20.1,33.3z"/>
        </IconBase>
    )
}

export default DictionaryEditIcon;